module.exports = __webpack_public_path__ + "img/BUY.7f0568a8.svg";